import { Component } from '@angular/core';

@Component({
    selector: 'app-oidc-callback',
    templateUrl: './oidc-callback.component.html',
    styleUrls: ['./oidc-callback.component.scss'],
    standalone: false
})
export class OidcCallbackComponent {

}
